module.exports = __webpack_public_path__ + "static/media/grabbing.99c580ff.cur";